import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import BackArrow from "assets/back-arrow.svg";
import ThemeStore from "stories/ThemeStore"
import Plus from '../../assets/plusWhite.svg'
import Edit from '../../assets/edit.svg'
import React, { useEffect, useRef, useState } from "react";
import { useArtists } from "components/NewRelease/hooks/useArtists";
import { ProgressSpinner } from "primereact/progressspinner";
import { useReleases } from "components/Releases/hooks/useReleases";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import Line from '../../assets/slantedline.svg'
import Copy from '../../assets/copy.svg'
import Trash from '../../assets/trash.svg'
import Modal from "components/Artists/Modal";
import { Toast } from 'primereact/toast';
import { useSocialLinks } from "components/NewRelease/hooks/useSocial";
import Instagram from '../../assets/instagram.svg'
import Vkontakte from '../../assets/vkontakte.svg'
import Close from '../../assets/close.svg'
import Facebook from '../../assets/facebook.svg'

import {
  Container, ArtistsHead, Overview, Channel, Products, Headline, Title, Content, UnLinkBox, Box, Input, TextTitle , Text , YoutubeBox, AddBox, ArtistInfo, InfoBox, NameBox, Info, Round , IdInfo, ArtistInfoBox,
  DeleteBox,IconWrapperBox,IconWrapperBigBox, EditBox, Save,LoadingBox , Loading, ButtonBox, ModalButtonBox, YesBox, ModalTitle , ModalName , InputBox, ProductsHeadBox ,HeadBox, PaginatorWrapper ,ReleasesRow, CoverImg , RoundBox, ReleaseTitle, ReleaseData, ReleaseDataBox, ReleaseDataBigBox , ReleaseISRC, NoBox,  TextBox, YoutubeRound, SocialBox , ContentBox , SocialInput ,ReleaseVersion, AddCover, CoverAddBox, ModalBody, ModalHead, BlueText, ModalTextBox, FooterBox , AddPhoto,  DeleteModalBox,FileInput, PreviewImage, PreviewBox, PreviewBoxRound, HoverPopupBox, HoverPopup,  BlackRound,  HoverPopupText, IconWrapper , BigImageBox ,CloseBox
  , HorizontalScroll, ReleasesList
} from '../Artists/styles/ArtistsDetailsStyles'
import IntlStore from "stories/IntlStore";
import {FormattedMessage} from "react-intl";

interface Artist {
  name?: string;
  youtube_id?: string;
  labels?: string[]
  main_genres?: string[]
  platforms?: string[]
  releases?: string[]
  genres: string[]
  networks?:[]
  cover_url?: string;
}
type DeleteDetails = {
  name: string;
  id?: string;
};

const isValidUrl = (str: string): boolean => {
  try {
    const url = new URL(str);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (_) {
    return false;
  }
};

export const ArtistsDetails = () => {
  const { id } = useParams()
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(10);
  const [first, setFirst] = useState<number>(0);
  const [filterArtistIds, setFilterArtistIds] = useState<string[]>([String(id)]);
  const [filterContributorIds, setFilterContributorIds] = useState<string[]>([]);
  const [filterLabelIds, setFilterLabelIds] = useState<string[]>([]);
  const [filterPlatformIds, setFilterPlatformIds] = useState<string[]>([])
  const [showDelModal, setShowDelModal] = useState<string | false>('');
  const [delError, setDelError] = useState('')
  const [editYoutubeId, setEditYoutubeId] = useState(false)
  const [valueId, setValueId] = useState<string | undefined>('');
  const [socValue, setSocValue] = useState('')
  const [bigImage, setBigImage] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const toast = useRef<Toast>(null);
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width: 768px)").matches;
  });

  const {deleteSocialLink, createSocialLink, fetching: socfetching, socialLinks} = useSocialLinks()

  const { fetching, upDateArtist, artist, getArtist, removeArtist } = useArtists();
  const { releases, total } = useReleases(
    selectedStatus,
    currentPage,
    pageCount,
    filterArtistIds,
    filterPlatformIds,
    filterLabelIds,
    filterContributorIds
  );



  const typedArtist = artist as Artist | undefined;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const theme = ThemeStore.activeTheme;
  const [editName, setEditName] = useState(false)
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(fetching);
  const [youtubeId, setYoutubeId] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [deteteDetalis, setDeteteDetalis] = useState<DeleteDetails | null>(null);
  const [preview, setPreview] = useState<string | null | undefined>(typedArtist?.cover_url || null || undefined);


  const downloadImage = (url: string) => {
    const extension = url.split('.').pop()?.split('?')[0] || 'jpg';
    const a = document.createElement('a');
    a.href = `/api/download?url=${encodeURIComponent(url)}`;
    a.download = `image.${extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const valid = isValidUrl(socValue);
  const getSocialIcon = (url: string) => {
    if (!url) return null;
    if (url.includes("instagram.com")) return <Instagram />;
    if (url.includes("vk.com")) return <Vkontakte/>;
    if (url.includes("facebook.com")) return <Facebook/>;

  };

  const handleOpenFile = () => {
    inputRef.current?.click();
  };

  const handleDelete = async () => {
    if (!deteteDetalis) return;

    try {
      if (deteteDetalis.name === "the YouTube Channel") {
        await upDateArtist(String(id), { youtube_id: null });
      } else if (deteteDetalis.name === "cover art") {
        await upDateArtist(String(id), { cover: undefined });
        setPreview(null);
      } else if (deteteDetalis.id) {
        await deleteSocialLink(deteteDetalis.id);
      }
      setDeteteDetalis(null);
    } catch (error) {
      console.error('Failed to delete:', error);

    }
  };


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowed = ['image/jpeg', 'image/png'];
    if (!allowed.includes(file.type)) {
      toast.current?.show({
        severity: 'error',
        summary: 'Invalid Format',
        detail: IntlStore.intl.formatMessage({
          id: "ArtistsDetails.UploadFileTypeError",
          defaultMessage: "Only JPEG or PNG files are allowed"
        }),
        life: 4000,
      });
      setPreview(null);
      e.target.value = ''
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.src = url;

    img.onload = () => {
      if (img.width < 500 || img.height < 500 || img.width !== img.height) {
        toast.current?.show({
          severity: 'error',
          summary: 'Invalid Dimensions',
          detail: IntlStore.intl.formatMessage({
            id: "ArtistsDetails.UploadFileSizeError",
            defaultMessage: "Image must be at least 500x500px and square"
          }),
          life: 4000,
        });
        URL.revokeObjectURL(url);
        setPreview(null);
        e.target.value = ''
        return;
      }
      setPreview(url)

      upDateArtist(String(id), {cover:file})
      setIsOpen(false);
    };

    img.onerror = () => {
      toast.current?.show({
        severity: 'error',
        summary: 'Load Error',
        detail: IntlStore.intl.formatMessage({
          id: "ArtistsDetails.CommonError",
          defaultMessage: "Unable to load image"
        }),
        life: 4000,
      });
      URL.revokeObjectURL(url);
      setPreview(null);
      e.target.value = ''
    };
  };

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setCurrentPage(event.page + 1);
    setFirst(event.rows * event.page);
    setPageCount(event.rows);
  };

  const handleDeleteClick = (id: string) => {
    setShowDelModal(id);
  };

  const handleClose = () => {
    setShowDelModal('');
  };

  useEffect(() => {

    (async () => await getArtist(String(id)))();
  }, []);

  useEffect(() => {
    typedArtist && setValue(typedArtist.name || '')
  }, [typedArtist?.name])

  useEffect(() => {
    setLoading(fetching)
  }, [fetching])

  useEffect(() => {
    setPreview(typedArtist?.cover_url || null)
  }, [typedArtist?.cover_url])

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(max-width: 768px)");
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    if ((mql as any).addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    (mql as any).addListener?.(onChange);
    return () => (mql as any).removeListener?.(onChange);
  }, []);



  return (
    <Container>
      <ArtistsHead>
        <Headline onClick={() => navigate('/artists')}>
          Artists
          <BackArrow color={theme.palette.text.breadcrumbs} />
          {typedArtist?.name}
        </Headline>
        {loading ? (<LoadingBox>
          <Loading>
            <ProgressSpinner />
          </Loading>
        </LoadingBox>) : <ArtistInfo >
          <ArtistInfoBox>
            {preview ? <PreviewBox><PreviewBoxRound><BlackRound/> <BlackRound/> <BlackRound/><HoverPopupBox className="popupBox"> <HoverPopup className="popup"><HoverPopupText  onClick={()=>{handleOpenFile()}}><FileInput
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
            <FormattedMessage
              id="ArtistsDetails.ReplaceCoverArt"
              defaultMessage="Replace cover art"
            />
            </HoverPopupText>
              <HoverPopupText onClick={()=>setBigImage(true)}>
                <FormattedMessage
                  id="ArtistsDetails.PreviewCoverArt"
                  defaultMessage="Preview cover art"
                />
              </HoverPopupText><HoverPopupText onClick={() => downloadImage(preview)}>
                <FormattedMessage
                  id="ArtistsDetails.DownloadCoverArt"
                  defaultMessage="Download cover art"
                />
            </HoverPopupText> <HoverPopupText onClick={()=>setDeteteDetalis({name:'cover art'})}>
              <FormattedMessage
                id="ArtistsDetails.DeleteCoverArt"
                defaultMessage="Delete cover art"
              />
            </HoverPopupText>
            </HoverPopup></HoverPopupBox></PreviewBoxRound>
            <PreviewImage src={preview} alt="Preview" /></PreviewBox>:
              <AddCover>
            <CoverAddBox onClick={()=>setIsOpen(true)}>
            <span>
              +
              <FormattedMessage
                id="ArtistsDetails.AddCoverArt"
                defaultMessage="Add cover art"
              />
            </span>
            <FileInput
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
            </CoverAddBox>
            </AddCover>}
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <Toast ref={toast} />

               <ModalBody>
                  <ModalHead>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirements"
                      defaultMessage="Cover Requirements"
                    />
                  </ModalHead>
                  <ModalTextBox><BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText1"
                      defaultMessage="Originality:"
                    />
                  </BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText1Text"
                      defaultMessage=" Only use original, non-copyrighted images"
                    />
                
                  </ModalTextBox>
                  <ModalTextBox><BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText2"
                      defaultMessage="Accuracy: "
                    />
                  </BlueText>
                  <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText2Text"
                      defaultMessage=" The cover should not be misleading. Only include the artist's name, album title, label name, release year, and copyright owner’s name"
                    /></ModalTextBox>
                  <ModalTextBox><BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText3"
                      defaultMessage="Quality:"
                    />
                  </BlueText>
                 
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText3Text"
                      defaultMessage="JPEG or PNG formats, resolution of at least 500x500 pixels, 1:1 ratio, RGB. No blurring or pixelation"
                    />
                  </ModalTextBox>
                  <ModalTextBox><BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText4"
                      defaultMessage="Cultural Sensitivity: "
                    />
                  </BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText4Text"
                      defaultMessage="No promotion of hate based on race, religion, gender, or other characteristics"
                    />
                  </ModalTextBox>
                  <ModalTextBox><BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText5"
                      defaultMessage="Prohibited Elements: "
                    />
                  </BlueText>
                    <FormattedMessage
                      id="ArtistsDetails.CoverRequirementsText5Text"
                      defaultMessage="Links, hashtags, copyrighted logos, pornographic or offensive material, drug promotion, racism, violence, images of celebrities or famous artworks"
                    />
                  </ModalTextBox>
                  <FooterBox>
                    <div onClick={() => setIsOpen(false)}>
                      <FormattedMessage
                        id="ArtistsDetails.Cancel"
                        defaultMessage="Cancel"
                      />
                    </div>
                    <AddPhoto onClick={handleOpenFile}>
                      <FormattedMessage
                        id="ArtistsDetails.AddCoverArt"
                        defaultMessage="Add cover art"
                      />
                    </AddPhoto>
                  </FooterBox>
                </ModalBody>
            </Modal>
            <InfoBox>
              {!editName ? <NameBox>
                <span>{typedArtist?.name}</span>
                <div style={{ cursor: 'pointer' }} onClick={() => setEditName(true)}><Edit /></div>
              </NameBox> : <EditBox>
                <Input>
                  <input value={value} onChange={(e) => setValue(e.target.value)} />
                </Input>  <Save disabled={!value} onClick={() => { setValue(''), upDateArtist(String(id), { name: value }).then(() => getArtist(String(id))), setEditName(false) }}>
                <FormattedMessage
                  id="ArtistsDetails.Save"
                  defaultMessage="Save"
                />
              </Save>
              </EditBox>}
              <Info>
                <IdInfo> ID: {id} <Round /> {typedArtist?.releases?.length || 0}
                  <FormattedMessage
                    id="ArtistsDetails.Products"
                    defaultMessage=" products"
                  />
                </IdInfo>
              </Info>

            </InfoBox>
          </ArtistInfoBox>
          <div onClick={() => handleDeleteClick(String(id))} >
            < DeleteBox>
              <FormattedMessage
                id="ArtistsDetails.DeleteArtist"
                defaultMessage="Delete artist"
              />
            </DeleteBox>
          </div>
        </ArtistInfo>}
      </ArtistsHead>
      <Overview>
        <Title>
          <FormattedMessage
            id="ArtistsDetails.Overview"
            defaultMessage="Overview"
          />
        </Title>
        <Content>
          {loading ?
            <Loading>
              <ProgressSpinner />
            </Loading>
            : <>
              <Box>
                <TextTitle>
                  <FormattedMessage
                    id="ArtistsDetails.Label"
                    defaultMessage="Label"
                  />
                </TextTitle>
                <Text>{typedArtist?.labels?.join(', ')}</Text>
              </Box>
              <Box>
                <TextTitle>
                  <FormattedMessage
                    id="ArtistsDetails.MainGenre"
                    defaultMessage="Main genre"
                  />
                </TextTitle>
                <Text>{typedArtist?.main_genres?.join(', ')}</Text>
              </Box>
              <Box>
                <TextTitle>
                  <FormattedMessage
                    id="ArtistsDetails.AdditionalGenre"
                    defaultMessage="Additional genre"
                  />
                </TextTitle>
                <Text>{typedArtist?.genres?.join(', ')}</Text>
              </Box>
            </>}
        </Content>
      </Overview>
      <Channel>
        <Title>
          <FormattedMessage
            id="ArtistsDetails.YoutubeOfficialArtistChannel"
            defaultMessage="Youtube Official Artist Channel"
          />
            <AddBox 
            style={{ opacity: youtubeId   ? '0.7' : '1' }} 
            onClick={() => 
            !youtubeId  && 
            setShowModal(true)}><Plus />
              <span>
                <FormattedMessage
                  id="ArtistsDetails.LinkYoutubeChannel"
                  defaultMessage="Link Youtube channel"
                />
              </span>
            </AddBox></Title>
        {loading ? (
          <Loading>
            <ProgressSpinner />
          </Loading>
        ) : typedArtist?.youtube_id !== 'null' && typedArtist?.youtube_id   ? <Content>
          <Box>
            <TextTitle>
              <FormattedMessage
                id="ArtistsDetails.Status"
                defaultMessage="Status"
              />
            </TextTitle>
            <Text>
              <FormattedMessage
                id="ArtistsDetails.Linked"
                defaultMessage="Linked"
              />
            </Text>
          </Box>
          <Box>
            <TextTitle>
              <FormattedMessage
                id="ArtistsDetails.ChannelID"
                defaultMessage="Channel ID"
              />
            </TextTitle>
            <YoutubeBox>
              <YoutubeRound>{
                !editYoutubeId ? <><Text>{typedArtist?.youtube_id}</Text>
                  <div onClick={() => (setEditYoutubeId(true), setValueId(typedArtist?.youtube_id))} style={{cursor:'pointer'}}>
                    <Edit />
                  </div>
                </> : <>
                  <input value={valueId} onChange={(e) => setValueId(e.target.value)} />
                </>
              }
              </YoutubeRound>
              {editYoutubeId && <Save disabled={!valueId} onClick={() => {setEditYoutubeId(false), upDateArtist(String(id), { youtube_id: valueId }).then(() => getArtist(String(id))), setValueId('') }}>
                <FormattedMessage
                  id="ArtistsDetails.Save"
                  defaultMessage="Save"
                />
              </Save>
              }
              <div style={{cursor:'pointer'}} onClick={()=>{
                setDeteteDetalis({name:'the YouTube Channel'})
                setYoutubeId('')
                }}>
                <Trash />
                </div>
            </YoutubeBox>
          </Box>
          <Box>
            <TextTitle>
              <FormattedMessage
                id="ArtistsDetails.ChannelType"
                defaultMessage="Channel type"
              />
            </TextTitle>
            <Text>
              <FormattedMessage
                id="ArtistsDetails.OAC"
                defaultMessage="OAC"
              />
            </Text>
          </Box>
        </Content> : <UnLinkBox>
          <FormattedMessage
            id="ArtistsDetails.NoYoutubeChannelLinkedYet"
            defaultMessage="No Youtube channel linked yet"
          />
        </UnLinkBox>}
      </Channel>
      <Channel>
        <Title>
          <FormattedMessage
            id="ArtistsDetails.SocialMedia"
            defaultMessage="Social Media"
          />
        </Title>
        {socfetching ? (
          <Loading>
            <ProgressSpinner />
          </Loading>
        ) :  <ContentBox>
          <SocialBox>
            {
              socialLinks?.map((network:any, index) => (
                <div key={index} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px',}}>
                    <SocialInput>
                      <IconWrapperBigBox>
                      <IconWrapperBox>
                      <IconWrapper>{getSocialIcon(network?.link)}</IconWrapper>
                      <div>
                     { network?.link}
                      </div>
                      </IconWrapperBox>
                      <div className="copyAction" style={{ cursor: 'pointer' }}   onClick={() =>
                            navigator.clipboard.writeText( network?.link ?? '')
                          }
                        >
                      <Copy/>
                      </div>
                      </IconWrapperBigBox>
                      </SocialInput>
                      <div
                        onClick={() => {
                          const name = new URL(network?.link).hostname.replace('www.', '').split('.')[0];
                          setDeteteDetalis({ name: `${name} link`, id: network?.id });
                        }}
                        style={{ cursor: 'pointer' }}
                      >

                      <Trash />
                    </div>

                </div>
              ))
            }
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <SocialInput>
              <IconWrapper>{socValue && getSocialIcon(socValue)}</IconWrapper>
              <input
                placeholder={IntlStore.intl.formatMessage({
                  id: "ArtistsDetails.SocialMediaLinkPlaceholder",
                  defaultMessage: "Enter the Social Media link"
                })}
                onChange={(e)=>setSocValue(e.target.value)}
                value={socValue}
              />
              <div className="copyAction" style={{ cursor: 'pointer' }}   onClick={() =>
                            navigator.clipboard.writeText( socValue ?? '')
                          }
                        >
                      <Copy/>
                      </div>
            </SocialInput>
              <div
              onClick={()=> setSocValue('')}
               style={{ cursor: 'pointer', opacity: !valid ? '0.7' : '1' }}>
              <Trash/>
            </div>
            </div>
          </SocialBox>
          <AddBox style={{ opacity:  !valid ? '0.7' : '1' }} onClick={() => valid && createSocialLink(socValue).then(()=> setSocValue(''))}><Plus /><span >
              <FormattedMessage
                id="ArtistsDetails.LinkSocialMedia"
                defaultMessage="Link Social Media"
              />
          </span></AddBox>
        </ContentBox> }
      </Channel>
      <Products>
        <Title>{typedArtist?.releases?.length}
          <FormattedMessage
            id="ArtistsDetails.Products"
            defaultMessage=" products"
          />
        </Title>
        {loading ? (
          <Loading>
            <ProgressSpinner />
          </Loading>
        ) : <>
        <HorizontalScroll>
          <ProductsHeadBox> <HeadBox>
          <FormattedMessage
            id="ArtistsDetails.Title"
            defaultMessage="Title"
          /> </HeadBox> <HeadBox>
          <FormattedMessage
            id="ArtistsDetails.ReleaseVersion"
            defaultMessage="Release version"
          />
        </HeadBox> <HeadBox>ISRC </HeadBox>
          <HeadBox>
            <FormattedMessage
              id="ArtistsDetails.DateAdded"
              defaultMessage="Date added"
            />
          </HeadBox> <HeadBox>
            <FormattedMessage
              id="ArtistsDetails.ReleaseDate"
              defaultMessage="Release date"
            />
        </HeadBox> </ProductsHeadBox>
          <ReleasesList>
          {releases.map((release, index) => (
            <ReleasesRow key={release.id} style={{ background: index === releases?.length - 1 ? "#E9E9E9" : undefined }}>
              <ReleaseDataBox>
                <CoverImg src={`${release?.cover_url}`} />
                <RoundBox>
                  <Line />
                </RoundBox>
                <ReleaseTitle>{release?.title}</ReleaseTitle>
              </ReleaseDataBox>
              <ReleaseDataBigBox>
                <ReleaseVersion>{release?.version}</ReleaseVersion>
                <ReleaseISRC>{release?.isrc}
                  {release?.isrc && <span style={{ cursor: 'pointer' }} onClick={() => navigator.clipboard.writeText(release?.isrc ?? '')}><Copy /></span>}      </ReleaseISRC>
                <ReleaseData>{release?.release_date}</ReleaseData>
                <ReleaseData><span style={{ paddingLeft: '57px' }}>{release?.original_release_date}</span></ReleaseData>
              </ReleaseDataBigBox>
            </ReleasesRow>
          ))}
          </ReleasesList>
          {!!releases.length && !!onPageChange && (
            <PaginatorWrapper>
              <Paginator
                first={first}
                rows={pageCount}
                totalRecords={total}
                rowsPerPageOptions={[5, 10, 20, 30]}
                onPageChange={onPageChange}
                pageLinkSize={isMobile ? 1 : 5}
                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              />
            </PaginatorWrapper>
          )}
        </HorizontalScroll>
        </>}
      </Products>
        <Modal isOpen={bigImage} onClose={() => setBigImage(false)} width={"500px"}>
          <BigImageBox >
            <CloseBox onClick={() => setBigImage(false)}>
            <Close/>
            </CloseBox>
            {preview && <img src={preview} />}
          </BigImageBox>
        </Modal>
          <Modal isOpen={showModal} onClose={() => setShowModal(false)}  width="520px">
            <div style={{padding:'16px 11px 16px 15px'}}>
            <ModalTitle>
              <FormattedMessage
                id="ArtistsDetails.YoutubeOfficialArtistChannel"
                defaultMessage="Youtube Official Artist Channel"
              />
            </ModalTitle>
            <ModalName>[
              <FormattedMessage
                id="ArtistsDetails.ArtistName"
                defaultMessage="Artist name"
              />: {typedArtist?.name}]</ModalName>
            <span>
              <FormattedMessage
                id="ArtistsDetails.YoutubeO&OChannelID"
                defaultMessage="Youtube O&O Channel ID"
              />
            </span>
            <InputBox placeholder={IntlStore.intl.formatMessage({
              id: "ArtistsDetails.EnterYoutubeO&OChannelIDPlaceholder",
              defaultMessage: "Enter Youtube O&O Channel ID"
            })} onChange={(e) => setYoutubeId(e.target.value)} />
            <ButtonBox>
              <YesBox onClick={() => {
                upDateArtist(String(id), { youtube_id: youtubeId }).then(() => {
                  setShowModal(false);
                });
              }} style={{ opacity: youtubeId ? 1 : 0.5 }} >
                <FormattedMessage
                  id="ArtistsDetails.Next"
                  defaultMessage="Next"
                />
              </YesBox>
            </ButtonBox>
            </div>
          </Modal>
          <Modal isOpen={!!showDelModal} onClose={() => setShowDelModal('')} width="520px">
            <DeleteModalBox>
              {delError ? (
                <TextBox>
                  <span>
                    <FormattedMessage
                      id="ArtistsDetails.Text1"
                      defaultMessage="Artist can’t be deleted while active releases remain."
                    />
                  </span>
                  <span>
                    <FormattedMessage
                      id="ArtistsDetails.Text2"
                      defaultMessage="Artist can’t be deleted while active releases remain."
                    />
                  </span>
                  <span>
                    <FormattedMessage
                      id="ArtistsDetails.Text3"
                      defaultMessage="releases before trying again"
                    />
                  </span>
                </TextBox>
              ) : (
                <TextBox>
                  <FormattedMessage
                    id="ArtistsDetails.Text4"
                    defaultMessage="releases before trying again"
                  />
                </TextBox>
              )}
              <ModalButtonBox>
                {!delError && <NoBox onClick={handleClose}>
                  <FormattedMessage
                    id="ArtistsDetails.No"
                    defaultMessage="No"
                  />
                </NoBox>}
                <YesBox
                  onClick={() => {
                    if (delError) {
                      setDelError('');
                      setShowDelModal('');
                    } else {
                      if (showDelModal) {
                        removeArtist(showDelModal)   .then(() => {
                          setShowDelModal('');
                          navigate('/artists');
                        })
                        .catch((error) => {
                          setDelError(error.message || 'Something went wrong');
                        })
                      }
                    }
                  }}
                >
                {delError ? (
                  <FormattedMessage
                    id="ArtistsDetails.Ok"
                    defaultMessage="Ok"
                  />
                ) : (
                  <FormattedMessage
                    id="ArtistsDetails.Yes"
                    defaultMessage="Yes"
                  />
                )}
            </YesBox>
          </ModalButtonBox>
          </DeleteModalBox>
        </Modal>
        <Modal isOpen={!!deteteDetalis} onClose={() => setDeteteDetalis(null)} width="520px">
          <DeleteModalBox>
            <TextBox>
              <FormattedMessage
                id="ArtistsDetails.Question"
                defaultMessage="Are you sure you want to delete"
              />
               {deteteDetalis?.name}?</TextBox>
            <ModalButtonBox>
              <NoBox onClick={() => setDeteteDetalis(null)}>
                <FormattedMessage
                  id="ArtistsDetails.No"
                  defaultMessage="No"
                />
              </NoBox>
              <YesBox
                onClick={handleDelete}

              >
                <FormattedMessage
                  id="ArtistsDetails.Yes"
                  defaultMessage="Yes"
                />
              </YesBox>
            </ModalButtonBox>
          </DeleteModalBox>
        </Modal>
    </Container>
  );
};

